import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { isPlatformServer } from '@angular/common';

import { Store } from '@ngrx/store';

import { IdAndHash } from '@fcom/dapi';
import { snapshot } from '@fcom/rx';
import { isPresent } from '@fcom/core/utils';
import { orderFetchInformation, paymentStatus } from '@fcom/common-booking/store';
import { PaymentStatus } from '@fcom/common-booking/interfaces';
import { BOOKING_STEPS } from '@fcom/common/config/booking-config';
import { BookingAndAppState } from '@fcom/common/interfaces/booking';

import { acceptTerms, cartIdAndHash } from '../../../store/selectors';
import { BookingService } from '../../../services';

@Injectable({ providedIn: 'root' })
export class PurchaseCheckoutGuard implements CanActivate {
  constructor(
    private store$: Store<BookingAndAppState>,
    private bookingService: BookingService,
    @Inject(PLATFORM_ID) private platform: object
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    if (isPlatformServer(this.platform)) {
      return true;
    }

    if (this.paymentCheck()) {
      return true;
    }

    this.bookingService.setStep({ step: BOOKING_STEPS.PURCHASE_REVIEW });

    return false;
  }

  paymentCheck = (): boolean => {
    const termsAndCondition: boolean = snapshot(this.store$.pipe(acceptTerms()));
    const cartIdHash: IdAndHash = snapshot(this.store$.pipe(cartIdAndHash()));
    const pay: PaymentStatus = snapshot(this.store$.pipe(paymentStatus()));
    const orderIdHash: IdAndHash = snapshot(this.store$.pipe(orderFetchInformation()));

    return (
      termsAndCondition &&
      ((isPresent(cartIdHash) && isPresent(cartIdHash.id) && isPresent(cartIdHash.hash)) ||
        (isPresent(orderIdHash) && isPresent(orderIdHash.id) && isPresent(orderIdHash.hash))) &&
      PaymentStatus.PENDING_VERIFICATION !== pay
    );
  };
}
